
const $ = require('cash-dom');

const axios = require('axios');

import dayjs from 'dayjs';  // date manipulation lib
import 'dayjs/locale/nl';  // locales for dayjs
import Litepicker from 'litepicker';  // date picker

import 'url-search-params-polyfill';

const format = 'YYYY-MM-DD';
const display_format = 'D MMM YYYY';

const datepicker_config = {
  singleMode: true,
  numberOfMonths: 2,
  switchingMonths: 1,
  // numberOfColumns: 2,
  mobileFriendly: true,
  lockDaysFormat: format,
  autoApply: false,
  buttonText: { "apply": "Toepassen", "cancel": "Datum wissen" },
  showTooltip: false,
  showWeekNumbers: false,
};

var mapping = {
  'roomtype': 'Kamertype',
  'transporttype': 'Vervoer',
  'departure': 'Vertrekdatum',
  'departure_from': 'Vertrekdatum van',
  'departure_to': 'Vertrekdatum tot',
  'durations': 'Reisduur',
  'occupations': 'Aantal personen',
  'boardtype': 'Verzorging',
  'audience': 'Leeftijdsgroep',
  'category': 'Categorie',
  'departure_month': 'Vertrekmaand',
  'min_age': 'Leeftijd vanaf',
  'max_age': 'Leeftijd tot',
  'countries': 'Land',
  'regions': 'Streek',
  'checkins': 'Check-in datum',
  'checkouts': 'Check-out datum',
};

var display_types = {
  'departure' : 'date',
  // 'departure_from' : 'date',
  // 'departure_to' : 'date',
  'departure_from': 'select',
  'departure_to': 'select',
  'duration': 'select',
  'audience': 'select',
  'default': 'select',
  'countries': 'locations',
  'regions': 'locations',
  'checkins': 'date',
  'checkouts': 'date',
  'occupations': 'partyselect',
  'pets': 'partyselect',
};

/* welke filters worden er gebruikt en in welke volgorde: */

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


function identify (el, prefix) {
  var $el = $(el);

  if (!$el.attr('id')) {
    $el.attr('id', uuidv4());
  }
};




function FilterBox (type, options) {

  this._container =  undefined,
  this._selected =  false,
  this._options =  {
    'onChange': function() {},
    'display_type': false,
    'onAfterApply': () => {},
    'onAfterCancel': () => {},
  },
  this._datepicker = false,
  this._datepicker_range = 0,

  this.initialize = function(type, options) {
    options = options || {};

    this._type = type;

    if (options.onChange) {
      this._options.onChange = options.onChange
    }

    if (options.display_type) {
      this._options.display_type = options.display_type
    }
    else {
      this._options.display_type = display_types[type] || display_types['default'];
    }

    this._options.onAfterApply = options.onAfterApply ? options.onAfterApply.bind(this) : (e) => {};
    this._options.onAfterCancel = options.onAfterCancel ? options.onAfterCancel.bind(this) : (e) => {};

  },

  this.setSelected = function(selectedValue) {
    this._selected = selectedValue;
  },


  this.build = function(container) {

    // var div = $('<div>');
    // div.addClass(this._type);
    // div.addClass('filter-box');

    // var label = $('label', {
    //   className: 'control-label'
    // }).update(mapping[this._type] + ':');

    // div.append(label);

    var el;

    switch (this._options.display_type) {
      case 'select':
      default:
        el = this.buildSelect(container);
        break;

      case 'locations':
        el = this.buildLocations(container);
        break;

      case 'date':
        el = this.buildDateSelect(container);
        break;

      case 'partyselect':
        el = this.buildPartySelect(container);
        break;


      // case 'checkbox_group':
      //   el = this.buildCheckboxGroup(container);
      //   break;
    }

    this._container = el;

    return this._container;
  },


  this.buildSelect = function(container) {
    var select_container = $('<div>');
    select_container.addClass('col');

    var select = $('<select>');
    select.attr('name', this._type);
    select.addClass('form-select').addClass('mb-3');
    select.on('change', this.onSelectChange.bind(this));

    identify(select);

    // select_container.append(select);
    // container.append(select_container);
    container.append(select);

    return select;
  }

  this.buildLocations = function (container) {
    if (!container.hasClass('inputspec_container')) {
      container.addClass('inputspec_container');
    }

    if ($('#booking_location_container').length <= 0) {
      var locations_container = $('<div id="booking_location_container" class="input_box js_open_container" data-target="booking_location_prefs">' +
        '    <div class="values">Bestemming</div> ' +
        '    <span class="chevron bottom"></span> ' +
        '    <div class="booking_location_input_box widget_filter_container" id="booking_location_prefs"> ' +
        '        <div class="row"></div> ' +
        '        <div class="box_controls"> ' +
        '            <div class="cancel js_clear_location"> ' +
        '                Wissen ' +
        '            </div> ' +
        '            <div class="apply js_apply_location apply_pers_dog_only"> ' +
        '                Toepassen ' +
        '            </div> ' +
        '        </div>' +
        '    </div> ' +
        '</div>');

      container.append(locations_container);

      var that = this;
      locations_container.find('.apply').on('click', (e) => {
        $(locations_container).find('#booking_location_prefs').removeClass('active');
        that._options.onAfterApply();
      });

      locations_container.find('.cancel').on('click', (e) => {
        $(locations_container).find('#booking_location_prefs').removeClass('active');
        that._options.onAfterCancel();
      });
    }
    else {
      locations_container = $('#booking_location_container');
    }

    if ($('#all_' + this._type).length <= 0) {
      var options_container = $('<div class="col-12 col-md-6 fade_bottom"> ' +
        '  <b>' + mapping[this._type] + '</b> ' +
        '  <div class="scrollbox" id="all_' + this._type + '"></div> ' +
        '</div> ');

      $('#booking_location_prefs .row').append(options_container);
    }

    locations_container.on('click', (e) => {
      var $target = $(e.target).hasClass('js_open_container') ? $(e.target) : $(e.target).parent('.js_open_container').first();
      if ($target.length >= 1) {
        $("#" + $target.data('target')).addClass("active")
        // $("#" + $(this).data('target')).css("width", $(".booking_prefs_info").css("width"))
      }
    });



    return locations_container;
  }


  this.buildDateSelect = function (container) {
    var date_container = $('<div class="input_box date_container js_move_datepicker">' +
      '  <input type="hidden" name="'+this._type+'[]" value=""> ' +
      '  <input type="hidden" name="'+this._type+'[]" value=""> ' +
      '  <span class="value" id="'+ this._type +'_value">'+ mapping[this._type] +'</span>' +
      '  <span class="chevron bottom"></span>' +
      '</div>');

    container.append(date_container);

    var that = this;
    date_container.on('click', (ev) => {
     if (that.instance) {
      that._container.addClass('active');
      that.instance.show();
     }
     else {
      console.info('litepicker not initilazed yet..');
     }
    });

    return date_container;
  }


  this.buildPartySelect = function (container) {

    var party_select_container = $('#booking_spec_container');

    if (party_select_container.length <= 0) {
      var party_select_container = $('<div id="booking_spec_container" class="input_box js_open_container" ' +
      '     data-target="booking_spec_input_box"> ' +
      '     <div class="values"> ' +
      '         <span id="personvalue">0</span> Pers.</span> ' +
      '         <span id="dogvalue">0</span> Honden ' +
      '     </div> ' +
      '     <span class="chevron bottom"></span> ' +
      '      ' +
      '     <div class="booking_spec_input_box widget_filter_container" id="booking_spec_input_box"> ' +
      '         <div class="input_field"> ' +
      '             <div class="value"> ' +
      '                 <span class="head">Personen</span> ' +
      '                 <span class="descr">Vanaf 2 jaar</span> ' +
      '             </div> ' +
      '             <div class="input_controls"> ' +
      '                 <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_min"> ' +
      '                     - ' +
      '                 </div> ' +
      '                 <input id="party_persons" name="occupations" type="number" min="0" max="4" value="0"> ' +
      '                 <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_plus"> ' +
      '                     + ' +
      '                 </div> ' +
      '             </div> ' +
      '         </div> ' +
      // '         <div class="input_field"> ' +
      // '             <div class="value"> ' +
      // '                 <span class="head">Kinderen</span> ' +
      // '                 <span class="descr">3 t/m 17 jaar</span> ' +
      // '             </div> ' +
      // '             <div class="input_controls"> ' +
      // '                 <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_min"> ' +
      // '                     - ' +
      // '                 </div> ' +
      // '                 <input id="party_children" name="occupations_children" type="number" min="0" max="4" ' +
      // '                     value="0"> ' +
      // '                 <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_plus"> ' +
      // '                     + ' +
      // '                 </div> ' +
      // '             </div> ' +
      // '         </div> ' +
      // '         <div class="input_field"> ' +
      // '             <div class="value"> ' +
      // '                 <span class="head">Baby\'s</span> ' +
      // '                 <span class="descr">0 t/m 2 jaar</span> ' +
      // '             </div> ' +
      // '             <div class="input_controls"> ' +
      // '                 <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_min"> ' +
      // '                     - ' +
      // '                 </div> ' +
      // '                 <input id="party_babies" name="occupations_babies" type="number" min="0" max="4" value="0"> ' +
      // '                 <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_plus"> ' +
      // '                     + ' +
      // '                 </div> ' +
      // '             </div> ' +
      // '         </div> ' +
      '         <div class="input_field"> ' +
      '             <div class="value"> ' +
      '                 <span class="head">Hond(en)</span> ' +
      '             </div> ' +
      '             <div class="input_controls dogs"> ' +
      '                 <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_min"> ' +
      '                     - ' +
      '                 </div> ' +
      '                 <input id="party_pets" name="pets" type="number" min="0" max="4" value="0"> ' +
      '                 <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_plus"> ' +
      '                     + ' +
      '                 </div> ' +
      '             </div> ' +
      '         </div> ' +
      '         <div class="box_controls"> ' +
      '             <div class="cancel js_cancel_prefs"> ' +
      '                 Wissen ' +
      '             </div> ' +
      '             <div class="apply js_apply_prefs apply_pers_dog_only"> ' +
      '                 Toepassen ' +
      '             </div> ' +
      '         </div> ' +
      '     </div> ' +
      ' </div> ');

      container.append(party_select_container);

      $(party_select_container).find('.js_input_field_alter').on("click", function () {
        var curValue = parseInt($(this).parent().find("input").val(), 10);

        if ($(this).hasClass("js_input_min")) {
          if (curValue > parseInt($(this).parent().find("input").attr("min"), 10)) {
            $(this).parent().find("input").val(curValue - 1)
          }
        }
        else if ($(this).hasClass("js_input_plus")) {
          if (curValue < parseInt($(this).parent().find("input").attr("max"), 10)) {
            $(this).parent().find("input").val(curValue + 1)
          }
        }
      });

      party_select_container.on('click', (e) => {
        var $target = $(e.target).hasClass('js_open_container') ? $(e.target) : $(e.target).parent('.js_open_container').first();
        if ($target.length >= 1) {
          $("#" + $target.data('target')).addClass("active")
          // $("#" + $(this).data('target')).css("width", $(".booking_prefs_info").css("width"))
        }
      });

      var that = this;
      party_select_container.find('.apply').on('click', (e) => {
        that.onPartySelectChanged($(party_select_container).find('input#party_persons').val(), $(party_select_container).find('input#party_pets').val());
        $(party_select_container).find('#booking_spec_input_box').removeClass('active');
         that._options.onAfterApply();
      });

      party_select_container.find('.cancel').on('click', (e) => {
        $(party_select_container).find('input#party_persons').val(0)
        $(party_select_container).find('input#party_pets').val(0)
        that.onPartySelectChanged(null, null);
        $(party_select_container).find('#booking_spec_input_box').removeClass('active');
         that._options.onAfterCancel();
      });

    }
    else {
      party_select_container = $('#booking_spec_container');
    }


    return party_select_container;
  }




  this.onSelectChange = function(ev) {
    var el = ev.currentTarget;
    if (el) {
      this._options.onChange(el.name, el.options[el.selectedIndex].value);
    }
  },

  this.onDateChange = function (selected_dates) { // (dates, formatted, instance, context) {
    var search = [];
    selected_dates.forEach((el) => {
      search.push(el.format('YYYY-MM-DDT[00:00:00Z]'));
    });
    return this._options.onChange(this._type, search);
  },

  this.onLocationChange = (ev) => {
    var $target = $(ev.target);
    if (ev.target.checked) {
      this._options.onChange(this._type, $target.val());
    }
    else {
      this._options.onChange(this._type, '');
    }
  }

  this.onPartySelectChanged = (persons, pets) => {
    $(this._container).find('#personvalue').html(persons);
    $(this._container).find('#dogvalue').html(pets);
    this._options.onChange('occupations', persons, true);
    this._options.onChange('pets', pets);
  }

  this.updateSelect = function (filteroptions) {
    $(this._container).hide();

    var $select = $(this._container);
    $select.find('option').remove();

    var first_option = $('<option>');
    first_option.attr('value', -1);
    first_option.html(mapping[this._type]);

    $select.append(first_option);

    if (filteroptions.length >= 1) {
      for (var i = 0, ilen = filteroptions.length; i < ilen; i++) {
        // description = filteroptions[i].description[0].toUpperCase();
        // description += filteroptions[i].description.substring(1);
        var description = filteroptions[i].display;

        var option = $('<option>');
        option.attr('value',filteroptions[i].value)
        option.html(description);

        // option.addClass(filteroptions[i].available ? 'available' : 'unavailable');

        if (filteroptions[i].selected) {
          option.attr('selected', 'selected');
        }

        $select.append(option);
      }

      $(this._container).show();
    }
  }

  this.updateLocations = function (filteroptions) {
    var options_container = $('#all_' + this._type);

    options_container.hide();
    options_container.find('div.form-check').remove();

    var values_container = $('#booking_location_container > div.values');

    let source = this._type;

    if (filteroptions.length >= 1) {
      var that = this;

      filteroptions.forEach((option) => {
        var value_container = $('<div class="form-check">'+
        '  <input id="booking_location_'+ source +'_'+ option.value +'" '+
        '     class="form-check-input js_booking_location_'+ source +' facet-search" '+
        '     type="checkbox" ' +
        '     value="'+ option.value +'" '+
        '     name="'+ source +'[]" ' +
        '     '+ (option.selected ? ' checked="checked"' : '') +'>' +
        '  <label class="form-check-label" for="booking_location_'+ source +'_'+ option.value +'">' +
        '      '+ option.display +' <span class="__float-end">('+ option.count +')</span>' +
        '  </label>' +
        '</div>');

        options_container.append(value_container);

        $('#booking_location_'+ source +'_'+ option.value).on('change', that.onLocationChange);

        if (option.selected) {
          var selected_values = values_container.html() ? values_container.html().split(', ') : [];
          var filtered_selected_values = selected_values.filter((el) => {
            if (/bestemming/i.test(el)) {
              return false;
            }

            return true;
          });
          filtered_selected_values.push(option.display);
          values_container.html([...new Set(filtered_selected_values)].join(', '));
        }
      });

      options_container.show();
    }
  }

  this.markHighlighted = function () {
    if (this._datepicker_range > 0 && this.selected_dates.length >= 1) {
      var current_date = this.selected_dates[0];

      var prepend_start = dayjs(current_date.dateInstance).subtract(this._datepicker_range, 'day').format(format);
      var prepend_end = dayjs(current_date.dateInstance).subtract(1, 'day').format(format);
      var append_start = dayjs(current_date.dateInstance).add(1, 'day').format(format);
      var append_end = dayjs(current_date.dateInstance).add(this._datepicker_range, 'day').format(format);

      this.instance.setHighlightedDays([[prepend_start, prepend_end], [append_start, append_end]]);
    }
    else {
      this.instance.setHighlightedDays([]);
    }
  }

  this.updateDateSelect = function (filteroptions) {

    if (this.instance) {
      this.instance.destroy();
    }

    let conf = Object.assign({}, datepicker_config);
    conf.element = this._container.get(0);

    var that = this

    this.allowed_dates = [];
    this.selected_dates = [];

    filteroptions.forEach((el) => {
      that.allowed_dates.push(dayjs(el.display).format(format));

      if (el.selected) {
        that.selected_dates.push(dayjs(el.display));
      }
    });

    conf.lockDaysFilter = (date1, date2, pickedDates) => {
      let cur_date = dayjs(date1.dateInstance);
      return !that.allowed_dates.includes(cur_date.format(format));
    }

    // conf.startDate = dayjs(filteroptions[0].value).format(format);
    // conf.endDate = dayjs(filteroptions[filteroptions.length - 1].value).format(format);

    this.instance = new Litepicker(conf);

    if (this.selected_dates.length >= 1) {
      if (this._datepicker_range == 0) {
        this.instance.setDate(this.selected_dates[0].format(format));
        this.markHighlighted();
      }
    }


    this.instance.on('render:footer', (footer, date) => {
      var date_range_selectors = $('<button class="button-set-range '+ (this._datepicker_range == 1 ? 'active' : '') +'" data-range="1">&plusmn; 1 dagen</button>' +
        '<button class="button-set-range '+ (this._datepicker_range == 3 ? 'active' : '') +'" data-range="3">&plusmn; 3 dagen</button>' +
        '<button class="button-set-range '+ (this._datepicker_range == 7 ? 'active' : '') +'" data-range="7">&plusmn; 7 dagen</button>');
      $(footer).prepend(date_range_selectors);

      $(footer).find('button.button-set-range').on('click', (ev) => {
        var btn = $(ev.target);

        if (this._datepicker_range != btn.data('range')) {
          this._datepicker_range = btn.data('range');
        }
        else if (this._datepicker_range == btn.data('range')) {
          this._datepicker_range = 0;
        }

        this.markHighlighted()
      });
    });

    // when picker is being hided/closed
    this.instance.on('hide', () => {
      that._container.removeClass('active');
    });

    this.instance.on('preselect', (date1, date2) => {
      this.selected_dates = [date1];
      this.markHighlighted();
    });

    this.instance.on('button:apply', (date1, date2) => {
      let selected_date = dayjs(date1.dateInstance);
      var selected_dates = [];

      if (selected_date) {
        if (this._datepicker_range > 0) {
          var start = dayjs(selected_date).subtract(this._datepicker_range, 'day');
          var end = dayjs(selected_date).add(this._datepicker_range, 'day');
          selected_dates = [start, end];
        }
        else {
          selected_dates = [selected_date]
        }
      }

      this._date_form_update(selected_dates);

      that.onDateChange(selected_dates);
      that._options.onAfterApply();
    });

    this.instance.on('button:cancel', () => {
      this._date_form_update([]);
      that.onDateChange([]);
      that._options.onAfterCancel();
    });

    this._date_form_update(this.selected_dates);

    $(this._container).show();
  }

  this._date_form_update = (selected_dates) => {
    if (selected_dates.length >= 1) {
      if (selected_dates.length == 1) {
        this._container.find('span.value').html(selected_dates[0].format('DD MMM YYYY'));
      }
      else {
        this._container.find('span.value').html(
          selected_dates[0].format('DD MMM YYYY') + ' t/m ' + selected_dates[selected_dates.length - 1].format('DD MMM YYYY')
        );
      }

      this._container.find('input[name="'+ this._type + '[]"]').each((idx, el) => {
        if (idx == 0) {
          $(el).val(selected_dates[0].format('YYYY-MM-DDT[00:00:00Z]'));
        }
        else {
          $(el).val(selected_dates[selected_dates.length - 1].format('YYYY-MM-DDT[00:00:00Z]'));
        }
      });
    }
    else {
      this._container.find('span.value').html(mapping[this._type]);
      this._container.find('input[name="'+ this._type + '[]"]').each((idx, el) => {
        $(el).val('');
      });
    }
  }

  this.updatePartySelect = function (filteroptions) {
    let selected = false;
    filteroptions.forEach((el) => {
      if (el.selected) {
        selected = el;
      }
    });

    var npt = this._container.find('input[name="'+ this._type + '"]');

    npt.attr('min', filteroptions[0].value).attr('max', filteroptions[filteroptions.length - 1].value);

    if (selected) {
      npt.val(selected.value);
    }

    switch (this._type) {
      case 'occupations':
        this._container.find('span#personvalue').html(selected.value);
        break;
      case 'pets':
        this._container.find('span#dogvalue').html(selected.value);
        break;
    }

    this._container.find('input[name="'+ this._type + '"]');
  }

  this.update = function(filteroptions) {
    var that = this;

    switch (display_types[this._type]) {
      case 'select':
      default:
        this.updateSelect(filteroptions);
        break;

      case 'locations':
        this.updateLocations(filteroptions);
        break;

      case 'date':
        this.updateDateSelect(filteroptions);
        break;

      case 'partyselect':
        this.updatePartySelect(filteroptions);
        break;
    }
  }

  this.initialize(type, options);

  return this;
};




function CallToActionBox (containerElement, options) {
  this._options = {
    'onClick': function() {},
  },
  this.initialize = function(containerElement, options) {
    this._options = options;
    this._container = containerElement;
    this._el;
  },
  this.build = function() {
    var div = $('<div>');
    div.addClass('cta-container')

    var btn = $('<button>')
    btn.addClass('btn').addClass('btn--primary');


    this._el = btn;
    btn.on('click', this.onClick.bind(this));

    this._container.append(this._el);
  },
  this.update = function(content) {
    this._el.html(content);
  },
  this.onClick = function(e) {
    this._options.onClick(e);
  }


  this.initialize(containerElement, options);
};

function ResetBox (containerElement, options) {
  this._options = {
    'onClick': function() {},
  },

  this.initialize = function(containerElement, options) {
    this._options = options;
    this._container = containerElement;
    this._ed;
  },

  this.build = function() {
    var div = $('div', {
        'class': 'reset-container'
      }),
      btn = $('button', {
        'class': 'btn-reset button btn-block'
      });

    this._el = btn;
    btn.on('click', this.onClick.bind(this));

    this._container.append(this._el);
  },
  this.update = function(content) {
    this._el.html(content);
  },
  this.onClick = function(e) {
    this._options.onClick(e);
  }


  this.initialize(containerElement, options);
};

function SearchQuery () {
  this._params = {},

  this.initialize = function() {
    this._search = new URLSearchParams(document.location.search);
  },

  this.search = function(name, value) {

    if (Array.isArray(value)) {
      var multi_name = name + '[]';

      if (this._search.has(name)) {
        this._search.delete(name);
      }

      this._search.delete(multi_name);

      value.forEach((el, idx) => {

        idx == 0
          ? this._search.set(multi_name, el)
          : this._search.append(multi_name, el);

      });

      return;
    }

    if (value !== -1 && value !== "-1") {
      this._search.set(name, value);  // _params[name] = value;
      this._search.set('search', name);  // _params['search'] = name;
    }
    else if (this._search.has(name)) { // (this._params[name]) {
      // delete this._params[name];
      this._search.delete(name);
    }
    return;
  },

  this.toString = function() {
    return '?' + this._search.toString();
  }

  this.getParams = function () {
    return this._search;
  }

  this.initialize();
};


function SearchBox (containerElement, options) {
  this.options = {
    'endpoint': '/',
    'load': false,
    'reset': true,
    'cta': true,
    'filters': [],
    'updateFilters': false,
  },

  this.initialize = function(containerElement, options) {
    this._container = $(containerElement);
    this._query = new SearchQuery();
    this._filters = {};
    this._cta = false;

    for (var i in this.options) {
      if (typeof(options[i]) != 'undefined') {
        this.options[i] = options[i];
      }
    }

    if (options.onUpdateFilters) {
      this.onUpdateFilters = options.onUpdateFilters.bind(this);
    }

    if (options.onAfterUpdateFilters) {
      this.onAfterUpdateFilters = options.onAfterUpdateFilters.bind(this);
    }

    this.options.onAfterApply = options.onAfterApply || null;
    this.options.onAfterCancel = options.onAfterCancel || null;

    this.loadFilters();
  },

  this.loadFilters = function() {
    var that = this;

    axios.get(this.options.endpoint, {
      params: this._query.getParams()
    })
      .then(that.parseResponse.bind(that))
      .catch(function (error) {
        console.log(error);
      });
  },

  this.parseResponse = function(xmlHttpResponse) {
    var data = xmlHttpResponse.data;

    // global filters!!
    var filters = this.options.filters || [];
    for (var i = 0, ilen = filters.length; i < ilen; i++) {
      var filter_config = filters[i];

      if (typeof(this._filters[filter_config.search]) == 'undefined') {
        // console.info(filter_config);

        var box = new FilterBox(filter_config.search, {
          'onChange': (this.options.updateFilters ? this.options.updateFilters.bind(this) : this.updateFilters.bind(this)),
          'display_type': filter_config.display_type,
          'onAfterApply': this.options.onAfterApply || null,
          'onAfterCancel': this.options.onAfterCancel || null,
        });

        box.build(this._container);

        this._filters[filter_config.search] = box;
      }

      var filteroptions = data.facets[filter_config.source] || [];
      // var selected_option = data.selected[filter_config.source];

      // this._filters[filter_config.search].setSelected(selected_option);
      this._filters[filter_config.search].update(filteroptions);
    }

    // reset
    if ((!this._reset && this.options.reset) || (!this._cta && this.options.cta)) {
      var cnt = $('div', {
        className: 'controls'
      });

      if (!this._reset && this.options.reset) {
        this._reset = new ResetBox(this._container, {
          'onClick': this.resetPage.bind(this)
        });
        this._reset.build();
        this._reset.update('Opnieuw beginnen');
      }

      if (!this._cta && this.options.cta) {
        this._cta = new CallToActionBox(this._container, {
          'onClick': this.reloadPage.bind(this)
        });
        this._cta.build();
      }

    }

    if (this._cta) {
      this._cta.update('Toon ' + data.num_found + ' vakantie' + (data.num_found != 1 ? 's' : '') );
    }

    // if( data.filters.departure ) {
    //   this._cta.update('Toon ' + data.filters.departure.length + ' vakantie' + (data.filters.departure.length > 1 ? 's' : ''));
    // }
    // else {
      //
    // }

    // this._cta.update('Toon alle vakanties');
  },

  this.onUpdateFilters = function(name, value) {},

  this.updateFilters = function(filter, value, skip_reloading_filters=false) {
    // console.info([filter, value, skip_reloading_filters]);
    this.onUpdateFilters(filter, value);
    this._query.search(filter, value);
    if (!skip_reloading_filters) {
      this.loadFilters();
      this.onAfterUpdateFilters(filter, value);
    }
    else {
      console.info('skipped loading filters..');
    }
  },

  this.onAfterUpdateFilters = function(name, value) {},

  this.reloadPage = function() {
    var base = this.options.load || document.location.pathname;
    document.location = base + this._query.toString();
  },

  this.resetPage = function() {
    document.location = document.location.pathname;
  }

  this.initialize(containerElement, options);
};

export { FilterBox, ResetBox, CallToActionBox, SearchQuery, SearchBox};
